import * as React from 'react'

export const OneMonthCalendarIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M5 0C5.53125 0 6 0.46875 6 1V2H10V1C10 0.46875 10.4375 0 11 0C11.5312 0 12 0.46875 12 1V2H13.5C14.3125 2 15 2.6875 15 3.5V5H1V3.5C1 2.6875 1.65625 2 2.5 2H4V1C4 0.46875 4.4375 0 5 0ZM1 6H15V14.5C15 15.3438 14.3125 16 13.5 16H2.5C1.65625 16 1 15.3438 1 14.5V6ZM3 8.5V9.5C3 9.78125 3.21875 10 3.5 10H4.5C4.75 10 5 9.78125 5 9.5V8.5C5 8.25 4.75 8 4.5 8H3.5C3.21875 8 3 8.25 3 8.5ZM7 8.5V9.5C7 9.78125 7.21875 10 7.5 10H8.5C8.75 10 9 9.78125 9 9.5V8.5C9 8.25 8.75 8 8.5 8H7.5C7.21875 8 7 8.25 7 8.5ZM11.5 8C11.2188 8 11 8.25 11 8.5V9.5C11 9.78125 11.2188 10 11.5 10H12.5C12.75 10 13 9.78125 13 9.5V8.5C13 8.25 12.75 8 12.5 8H11.5ZM3 12.5V13.5C3 13.7812 3.21875 14 3.5 14H4.5C4.75 14 5 13.7812 5 13.5V12.5C5 12.25 4.75 12 4.5 12H3.5C3.21875 12 3 12.25 3 12.5ZM7.5 12C7.21875 12 7 12.25 7 12.5V13.5C7 13.7812 7.21875 14 7.5 14H8.5C8.75 14 9 13.7812 9 13.5V12.5C9 12.25 8.75 12 8.5 12H7.5ZM11 12.5V13.5C11 13.7812 11.2188 14 11.5 14H12.5C12.75 14 13 13.7812 13 13.5V12.5C13 12.25 12.75 12 12.5 12H11.5C11.2188 12 11 12.25 11 12.5Z"
        fill="currentColor"
      />
    </svg>
  )
}
